import React, { useEffect } from "react";
import {
  Container,
} from "reactstrap";
import Breadcrumbs from "components/Common/Breadcrumb";
import { CustomBootstrapTable } from 'components/Table/CustomBootstrapTable';
import {  ComboColumnList } from "helpers/tableDataMapper";
import { useSelector, useDispatch } from "react-redux";
import { getCombos, getWordiconPacks } from "store/actions";
import { MdEdit, MdOutlineRemoveRedEye } from "react-icons/md";
import { history } from "helpers/utils";

const ComboList = (props) => {
    const dispatch = useDispatch();

    const { combosList } = useSelector(state => ({
        combosList: state.combo.combosList,
    }));
    
    useEffect(() => {
        let queryPayload = {
            search: '',
        }
        dispatch(getCombos(queryPayload));
    }, [dispatch, props]);

    const getApplicationDetails = (row) => {
        props.history.push(`/staff/combo/detail/${row[8]}`)
    }
    const filterList = (queryPayload) => {
        let payload = {
            ...queryPayload
        }
        dispatch(getCombos(payload))
    }

    const getTableColumns = () => {
        let editObj = {
            label: "Actions",
            name: '',
            options: { 
                filter: true,
                sort: false, 
                customBodyRender: (value, tableMeta, updateValue) => (
                    <div className='d-flex align-items-center justify-content-center'>
                        <div
                            className="ms-1"
                            onClick={() => getApplicationDetails(tableMeta?.rowData)}
                        >
                            <MdEdit size={16}/>
                        </div>  
                    </div>
                )
            }
        }
        let newtable = [...ComboColumnList,editObj]
         return newtable
    }
    return (
        <React.Fragment>
            <div className="page-content">
                <Container fluid>
                    <Breadcrumbs title="Combo" breadcrumbItem="Combo List" />
                    <CustomBootstrapTable 
                        rows = {combosList}
                        columns = {getTableColumns()}
                        isLoading={false}
                        showCreateBtn = {true}
                        keyField={'_id'}
                        createBtnLabel="Create Combo"
                        onCreateRedirect = {`/staff/combo/detail`}
                        getApplicationDetails={(row) => null}
                        showStatusFilter={false}
                        showDateFilter={false}
                        history = {props.history}
                        filterList = {(...params) => filterList(...params)}
                    />
                </Container>
            </div>
        </React.Fragment>
    )
}

export { ComboList }